import {
    CheckOutline,
    CloseOutline,
    CloudOutline,
    CloudUploadOutline,
    DashboardOutline,
    FolderOutline,
    FormOutline,
    GiftOutline,
    HomeOutline,
    MenuFoldOutline,
    MenuUnfoldOutline,
    SettingOutline,
    TrademarkOutline,
    FilterOutline,
    DeleteOutline,
    StockOutline,
    DragOutline,
    ClockCircleOutline,
    SyncOutline,
} from "@ant-design/icons-angular/icons";

export const icons = [
    MenuFoldOutline,
    MenuUnfoldOutline,
    DashboardOutline,
    FormOutline,
    GiftOutline,
    FolderOutline,
    CheckOutline,
    CloudOutline,
    CloudUploadOutline,
    HomeOutline,
    TrademarkOutline,
    FilterOutline,
    CloseOutline,
    DeleteOutline,
    SettingOutline,
    StockOutline,
    DragOutline,
    ClockCircleOutline,
    SyncOutline,
];
